module.exports = __webpack_public_path__ + "img/image_of_content_after_load.a1d4ce9c.gif";